import React, { useEffect, useRef } from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { FileUpload } from "primereact/fileupload";
import { appConstantes, limitSize, nemonicoGruposCatalogos } from "../../constantes/appConstantes";
import {
  obtenerCantones,
  obtenerCatalogosPorNemGrupo,
  obtenerCatalogosPorNemGrupoYCodPadre,
  obtenerParroquias,
  obtenerProvincias,
  setListaCatalogosGrupo,
  setListaCatalogosGrupoYCodPadre,
} from "../../sliceRedux/Reserva.slice";
import { useSelector } from "react-redux";
import RenderToast from "../../componentes/RenderToast";
import { Image } from "primereact/image";
import { Button } from "primereact/button";
import { CounterString } from "../../componentes/CounterString";
import { Message } from "primereact/message";

const Entidad = (props) => {
  const { showLoader, hideLoader, dispatch, formikEntidad, toast } = props;
  const fileUploadRef = useRef(null);
  const listaTiposCajas = useSelector((state) => state.reserva.listaCatalogosGrupo);
  const listaTiposVinculo = useSelector((state) => state.reserva.listaCatalogosGrupoYCodPadre);
  const listaProvincias = useSelector((state) => state.reserva.listaProvincias);
  const listaCantones = useSelector((state) => state.reserva.listaCantones);
  const listaParroquias = useSelector((state) => state.reserva.listaParroquias);

  useEffect(() => {
    const fetchInitialData = async () => {
      showLoader();
      const promises = [
        dispatch(obtenerCatalogosPorNemGrupo(nemonicoGruposCatalogos.TIPO_CAJA)),
        dispatch(obtenerProvincias()),
      ];

      if (formikEntidad.values.tipoCaja !== "") {
        promises.push(
          dispatch(
            obtenerCatalogosPorNemGrupoYCodPadre(
              nemonicoGruposCatalogos.TIPO_CAJA,
              formikEntidad.values.tipoCaja
            )
          )
        );
      }
      await Promise.allSettled(promises);
      hideLoader();
    };

    fetchInitialData();
  }, []);

  useEffect(() => {
    return () => {
      hideLoader();
    };
  }, [listaCantones]);

  useEffect(() => {
    return () => {
      hideLoader();
    };
  }, [listaParroquias]);

  useEffect(() => {
    return () => {
      dispatch(setListaCatalogosGrupo({ ...listaTiposCajas, code: 0 }));
    };
  }, [listaTiposCajas.code]);

  useEffect(() => {
    if (listaTiposVinculo.code === 200) {
      hideLoader();
    }
    return () => {
      dispatch(setListaCatalogosGrupoYCodPadre({ ...listaTiposVinculo, code: 0 }));
    };
  }, [listaTiposVinculo.code]);

  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && <small className="p-error">{formikEntidad.errors[name]}</small>
    );
  };

  const isFormFieldValid = (name) => {
    const isValid = !!(formikEntidad.touched[name] && formikEntidad.errors[name]);
    return isValid;
  };

  const fileValidation = { isValid: true };
  const onSelectFile = (event) => {
    let file = event.files[0];
    if (file != undefined && !/^image\/(jpeg|png)$/.test(file?.type)) {
      RenderToast(
        toast,
        "warn",
        "Información",
        "Solo se permiten archivos en formato JPG, JPEG, PNG"
      );
      formikEntidad.setFieldValue("nombreCroquis", "");
      fileValidation.isValid = false;
    }
    if (fileValidation.isValid && file?.size <= 1050000) {
      let reader = new FileReader();
      reader.onload = (readerEvt) => {
        const arrayBuffer = readerEvt.target.result;
        const base64String = btoa(
          new Uint8Array(arrayBuffer).reduce((data, byte) => data + String.fromCharCode(byte), "")
        );
        formikEntidad.setFieldValue("nombreCroquis", file?.name);
        formikEntidad.setFieldValue("croquis", file);
        formikEntidad.setFieldValue("bytesCroquis", base64String);
      };
      reader.readAsArrayBuffer(file);
    }
    fileValidation.isValid = true;
    fileUploadRef.current.clear();
    return fileValidation.isValid;
  };

  return (
    <>
      <div className="card">
        <Fieldset legend="Datos de la organización">
          <div className="grid ">
            <div className="flex col-12 md:col-4">
              <label
                htmlFor="tipoCaja"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
                required
              >
                Tipo de caja
              </label>
              <div className="col">
                <Dropdown
                  id="tipoCaja"
                  name="tipoCaja"
                  optionLabel="nomCatalogo"
                  optionValue="codCatalogo"
                  value={formikEntidad.values.tipoCaja}
                  options={listaTiposCajas?.object ?? []}
                  emptyMessage={appConstantes.SIN_DATOS}
                  className={classNames({
                    "p-invalid": isFormFieldValid("tipoCaja"),
                  })}
                  onChange={(e) => {
                    formikEntidad.setFieldValue("tipoVinculo", "");
                    let caja = listaTiposCajas?.object?.find((x) => x.codCatalogo === e.value);
                    formikEntidad.setFieldValue("tipoCajaDescripcion", caja?.nomCatalogo ?? "");
                    formikEntidad.handleChange(e);
                    showLoader();
                    dispatch(
                      obtenerCatalogosPorNemGrupoYCodPadre(
                        nemonicoGruposCatalogos.TIPO_CAJA,
                        e.value
                      )
                    );
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("tipoCaja")}
              </div>
            </div>
            <div className="flex col-12 md:col-4">
              <label
                htmlFor="tipoVinculo"
                className="mr-2"
                style={{ minWidth: "100px", textAlign: "left" }}
                required
              >
                Tipo de vínculo común
              </label>
              <div className="col">
                <Dropdown
                  id="tipoVinculo"
                  name="tipoVinculo"
                  optionLabel="nomCatalogo"
                  optionValue="codCatalogo"
                  value={formikEntidad.values.tipoVinculo}
                  options={listaTiposVinculo?.object ?? []}
                  emptyMessage={appConstantes.SIN_DATOS}
                  className={classNames({
                    "p-invalid": isFormFieldValid("tipoVinculo"),
                  })}
                  onChange={(e) => {
                    let vinculo = listaTiposVinculo?.object?.find((x) => x.codCatalogo === e.value);
                    formikEntidad.setFieldValue(
                      "vinculoComunDescripcion",
                      vinculo?.nomCatalogo ?? ""
                    );
                    formikEntidad.setFieldValue("esPertencia", vinculo?.pertenencia ?? "N");
                    formikEntidad.handleChange(e);
                  }}
                  style={{ width: "100%" }}
                />
                {getFormErrorMessage("tipoVinculo")}
              </div>
            </div>
          </div>
        </Fieldset>
        <div className="p-2"></div>
        <Fieldset legend="Domicilio Legal">
          <div className="grid">
            <div className="col-12 md:col-4">
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="provincia"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Provincia:
                </label>
                <div className="col">
                  <Dropdown
                    id="provincia"
                    name="provincia"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formikEntidad.values.provincia}
                    options={listaProvincias}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    className={classNames({
                      "p-invalid": isFormFieldValid("provincia"),
                    })}
                    onChange={(e) => {
                      formikEntidad.setFieldValue("canton", "");
                      formikEntidad.setFieldValue("parroquia", "");
                      formikEntidad.handleChange(e);
                      showLoader();
                      dispatch(obtenerCantones(e.value));
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("provincia")}
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="canton"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Cantón:
                </label>
                <div className="col">
                  <Dropdown
                    id="canton"
                    name="canton"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formikEntidad.values.canton}
                    options={listaCantones}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    className={classNames({
                      "p-invalid": isFormFieldValid("canton"),
                    })}
                    onChange={(e) => {
                      formikEntidad.setFieldValue("parroquia", "");
                      formikEntidad.handleChange(e);
                      showLoader();
                      dispatch(obtenerParroquias(e.value));
                    }}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("canton")}
                </div>
              </div>

              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                  required
                >
                  Parroquia:
                </label>
                <div className="col">
                  <Dropdown
                    id="parroquia"
                    name="parroquia"
                    optionLabel="nombre"
                    optionValue="codigo"
                    value={formikEntidad.values.parroquia}
                    options={listaParroquias}
                    filter
                    emptyMessage={appConstantes.SIN_DATOS}
                    emptyFilterMessage={appConstantes.SIN_DATOS}
                    className={classNames({
                      "p-invalid": isFormFieldValid("parroquia"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("parroquia")}
                </div>
              </div>

              <Message
                severity="warn"
                className="mb-2"
                text="Estimado usuario el formato permitido JPG, JPEG, PNG y el peso máximo será de 1 MB"
              />

              <div className="col">
                <FileUpload
                  id="nombreCroquis"
                  name="nombreCroquis"
                  ref={fileUploadRef}
                  accept=".jpg,.jpeg,.png"
                  maxFileSize={1050000}
                  chooseOptions={{
                    icon: "pi pi-map",
                    className: "p-button-secondary p-button-rounded",
                  }}
                  onSelect={onSelectFile}
                  disabled={formikEntidad.values.nombreCroquis !== ""}
                  contentClassName="p-button-sm"
                  onValidationFail={(e) => {
                    formikEntidad.setFieldValue("nombreCroquis", "");
                    RenderToast(
                      toast,
                      "warn",
                      "Información",
                      "El tamaño máximo del archivo es 1MB"
                    );
                  }}
                  className="p-button-sm"
                  mode="basic"
                  customUpload
                  chooseLabel="Seleccionar croquis"
                  style={{ size: "5px" }}
                />
                {formikEntidad.values.nombreCroquis === "" && getFormErrorMessage("nombreCroquis")}
              </div>

              <div className="flex justify-content-center">
                {formikEntidad.values.nombreCroquis !== "" && (
                  <div className="relative inline-block">
                    <Image
                      src={"data:image/png;base64," + formikEntidad.values.bytesCroquis}
                      zoomSrc={"data:image/png;base64," + formikEntidad.values.bytesCroquis}
                      alt="Croquis"
                      width="150"
                      height="100"
                      preview
                    />
                    <Button
                      icon="pi pi-trash"
                      rounded
                      type="button"
                      tooltip="Eliminar"
                      severity="danger"
                      className="absolute top-0 right-0"
                      onClick={() => {
                        formikEntidad.setFieldValue("nombreCroquis", "");
                        formikEntidad.setFieldValue("bytesCroquis", "");
                      }}
                    ></Button>
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 md:col-8">
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="callePrincipal"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Calle principal:
                </label>
                <div className="col">
                  <InputTextarea
                    id="callePrincipal"
                    name="callePrincipal"
                    value={formikEntidad.values.callePrincipal}
                    autoComplete="off"
                    rows={2}
                    maxLength={limitSize.TEXT_INPUT}
                    className={classNames({
                      "p-invalid": isFormFieldValid("callePrincipal"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("callePrincipal")}
                  <CounterString
                    length={formikEntidad.values.callePrincipal.length}
                    maxLength={limitSize.TEXT_INPUT}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="calleSecundaria"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                  required
                >
                  Calle secundaria:
                </label>
                <div className="col">
                  <InputTextarea
                    id="calleSecundaria"
                    name="calleSecundaria"
                    value={formikEntidad.values.calleSecundaria}
                    autoComplete="off"
                    rows={2}
                    maxLength={limitSize.TEXT_INPUT}
                    className={classNames({
                      "p-invalid": isFormFieldValid("calleSecundaria"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("calleSecundaria")}
                  <CounterString
                    length={formikEntidad.values.calleSecundaria.length}
                    maxLength={limitSize.TEXT_INPUT}
                  />
                </div>
              </div>
              <div className="flex col-12 md:col-5">
                <label
                  htmlFor="numero"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                >
                  Número:
                </label>
                <div className="col">
                  <InputText
                    id="numero"
                    name="numero"
                    value={formikEntidad.values.numero}
                    autoComplete="off"
                    maxLength={limitSize.TEXT_INPUT_NUMBER}
                    className={classNames({
                      "p-invalid": isFormFieldValid("numero"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("numero")}
                </div>
              </div>

              <div className="flex col-12 md:col-12">
                <label
                  htmlFor="parroquia"
                  className="mr-2"
                  style={{ minWidth: "110px", textAlign: "left" }}
                >
                  Referencia:
                </label>
                <div className="col">
                  <InputTextarea
                    id="referencia"
                    name="referencia"
                    rows={3}
                    maxLength={limitSize.TEXT_AREA}
                    value={formikEntidad.values.referencia}
                    autoComplete="off"
                    className={classNames({
                      "p-invalid": isFormFieldValid("referencia"),
                    })}
                    onChange={formikEntidad.handleChange}
                    style={{ width: "100%" }}
                  />
                  {getFormErrorMessage("referencia")}
                  <CounterString
                    length={formikEntidad.values.referencia.length}
                    maxLength={limitSize.TEXT_AREA}
                  />
                </div>
              </div>
            </div>
          </div>
        </Fieldset>
      </div>
    </>
  );
};
export default Entidad;
